import axios from 'services/network/axios';

//  *** AppSettings
export const GetAppSettings = () => axios.get('Core/AppSettings');
